<template>
    <div>
        <van-row style="padding: 10px;">
            <van-col :span="4">
                <div style=" display: flex; justify-content: center; align-items:flex-start;">
                    <img style=" width: 35%; object-fit: cover;border-radius: 10px" src="@/assets/download/share.png" />
                </div>
            </van-col>
            <van-col :span="20">
                <div v-for="(item, index) in dataShare" :key="index"
                    style="height: 25px;color: #5f6368; display: flex; justify-content: flex-start; align-items: center;">
                    <p style="margin: 0; font-size: 15px;">{{ item }}</p>
                </div>
            </van-col>
        </van-row>
        <van-row style="padding: 10px;">
            <van-col :span="4">
                <div style=" display: flex; justify-content: center; align-items:flex-start;">
                    <img style=" width:35%; object-fit: cover;border-radius: 10px"
                        src="@/assets/download/dataUse.png" />
                </div>
            </van-col>
            <van-col :span="20">
                <div v-for="(item, index) in dataUse" :key="index"
                    style="color: #5f6368; display: flex; justify-content: flex-start; align-items: center;">
                    <p style="margin: 0; font-size: 15px;">{{ item }}</p>
                </div>
            </van-col>
        </van-row>
        <van-row style="padding: 10px;">
            <van-col :span="4">
                <div style=" display: flex; justify-content: center; align-items:flex-start;">
                    <img style=" width:35%; object-fit: cover;border-radius: 10px" src="@/assets/download/lock.png" />
                </div>
            </van-col>
            <van-col :span="20">
                <div v-for="(item, index) in dataLock" :key="index"
                    style="color: #5f6368; display: flex; justify-content: flex-start; align-items: center;">
                    <p style="margin: 0; font-size: 15px;">{{ item }}</p>
                </div>
            </van-col>
        </van-row>
        <van-row style="padding: 10px;">
            <van-col :span="4">
                <div style=" display: flex; justify-content: center; align-items:flex-start;">
                    <img style=" width:35%; object-fit: cover;border-radius: 10px" src="@/assets/download/trash.png" />
                </div>
            </van-col>
            <van-col :span="20">
                <div v-for="(item, index) in dataRemove" :key="index"
                    style="color: #5f6368; display: flex; justify-content: flex-start; align-items: center;">
                    <p style="margin: 0; font-size: 15px;">{{ item }}</p>
                </div>
            </van-col>
        </van-row>
    </div>
</template>
<script setup lang="ts">
import { computed, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
    img: {
        type: String,
        default: 'share'
    }
})
const { t } = useI18n();
const dataShare = computed(() => [t('download.dataShare'), t('download.datShareLearn')])
const dataUse = computed(() => [t('download.collectData'), t('download.appActivity')])
const dataLock = computed(() => [t('download.dataEncrypt')])
const dataRemove = computed(() => [t('download.reqDelete')])

</script>

<style scoped></style>